<script setup>
import { onMounted, ref, watch, inject, defineProps, defineEmits, defineExpose } from 'vue';
import i18n from "@/i18n"
import { showMessage } from "@/utils/hooks/message"
import moment from 'moment';
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import PreviewImg from "@/components/common/PreviewImg";
// import QRCode from "qrcode";
import { getLangValue, } from "@/utils/common"; //获取后端语言
const props = defineProps({
    dashboardType: {
        type: String,
        required: true,
        default: "quality",
    }
})
const colors = ['#5470c6', '#91cc75', '#3ba272', '#ee6666', '#73c0de']
const emits = defineEmits(['showCharts', 'showInstandard', 'sort', 'pageChange'])
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const tableInfo = ref([])
// const typeList = ref([])
const keyword = ref('')
const productsList = inject('productList')
const productList_total = inject('productList_total')
const selectedIndex = inject('selectedIndex') //当前选中的行
const showTable = inject('showTable')
const selectedTableData = ref([]) // 勾选中的数据
const selectedProductId = inject('selectedProductId')
const table_head = ref([
    { name: 'NO.', width: '2%', checked: true },
    { name: getLangValue("product-template.productName"), width: '9%', key: 'name', checked: true }, //产品名称
    // { name: getLangValue("product-template.type"), width: '9%', key: 'type', checked: true, }, // 类型
    // { name: getLangValue("product-template.batchValue"), width: '9%', key: 'batch_size', checked: true }, //批次数量
    { name: getLangValue("product-template.price"), width: '9%', key: 'price', checked: true }, //价格
    { name: getLangValue("product-template.size"), width: '9%', key: 'size', checked: true }, //尺寸
    { name: getLangValue("product-template.color"), width: '9%', key: 'color', checked: true }, //颜色
    { name: getLangValue("product-template.origin"), width: '9%', key: 'origin', checked: true }, //产地
    { name: getLangValue("product-management.supplier"), width: '9%', key: 'supplier', checked: true }, //供应商
    { name: getLangValue("dashboard.listingTime"), width: '9%', key: 'release_time', checked: true }, //产地
])

const pageSizeOption = [10, 20, 30, 40, 50]
const searchInfo = ref({
    orderBy: 'desc',
    sortField: 'total_value',
})
// const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const normalizeSelectedTableData = () => {
    selectedTableData.value = selectedTableData.value.map((item, index) => ({
        ...item,
        number: index + 1,
    }))
}

const setTableData = () => {
    // 根据分页
    // 根据group筛选
    // let startIndex = ((currentPage.value - 1) * pageSize.value) - 1 < 0 ? 0 : ((currentPage.value - 1) * pageSize.value);
    // let endIndex = startIndex + pageSize.value;
    // // total.value = productsList.value.length
    // // tableInfo.value = productsList.value.slice(startIndex, endIndex)
    // if (keyword.value === '' || !keyword.value) {
    //     total.value = productsList.value.length
    //     tableInfo.value = JSON.parse(JSON.stringify([...productsList.value.slice(startIndex, endIndex)]))
    // } else {
    //     total.value = productsList.value.filter(
    //         item => item.organization.company_name.includes(keyword.value.trim())
    //             || item.production_line.place_of_origin.name.includes(keyword.value.trim())
    //             || item.production_line.place_of_origin.province.includes(keyword.value.trim())
    //             || item.production_line.place_of_origin.country.includes(keyword.value.trim())
    //     ).length
    //     tableInfo.value = JSON.parse(JSON.stringify([...productsList.value.filter(item =>
    //         item.organization.company_name.includes(keyword.value.trim())
    //         || item.production_line.place_of_origin.name.includes(keyword.value.trim())
    //         || item.production_line.place_of_origin.province.includes(keyword.value.trim())
    //         || item.production_line.place_of_origin.country.includes(keyword.value.trim())).slice(startIndex, endIndex)]))
    // }

    /***
     * 以前是前端分页  现在改成了后端分页
     */
    tableInfo.value = JSON.parse(JSON.stringify(productsList.value))
    tableInfo.value.forEach((item,) => {
        if (selectedTableData.value.findIndex(i => i.database_id == item.database_id && i.name == item.name) != -1) {
            item.checked = true
        }
        // if (item.testing_institution) {
        //     let opts = {
        //         errorCorrectionLevel: "M",
        //         margin: 1,
        //         width: 300,
        //         height: 300,
        //         quality: 1,
        //         color: {
        //             dark: "#000",
        //             light: "#FFF",
        //         },
        //     };
        //     let href = window.location.href
        //     let arr = href.split('/#/')
        //     let website = arr[0]
        //     QRCode.toDataURL(`${website}/#/code?content=${item.testingOrganization}`, opts, (err, url) => {
        //         if (err) throw err;
        //         item.qrcodeImgUrl = url;
        //     });
        // }
    })
    // 选中第一个
    if (selectedTableData.value.length == 0 && tableInfo.value.length > 0) {
        tableInfo.value[0].checked = true
        selectedTableData.value.push({
            ...tableInfo.value[0],
            number: 1,
        })
        normalizeSelectedTableData()
        emits('showCharts', selectedTableData.value);
    }
    tableInfo.value.length && setIndex(0)
}

const search = () => {
    //搜索
    currentPage.value = 1;
    emits('pageChange', { currentPage: currentPage.value, pageSize: pageSize.value, keyword2: keyword.value, })
}

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

// const getChecked = () => {
//     return table_head.value.filter(item => item.checked).length
// }
const remove = (key) => {
    // 图表移除pid
    let id = selectedTableData.value[key].id
    selectedTableData.value.splice(key, 1)
    tableInfo.value.forEach(item => {
        if (item.id == id)
            item.checked = false
    })
    normalizeSelectedTableData()
    emits('showCharts', selectedTableData.value);
}
const changCheckBox = (id, info) => {
    // 点击选中的  取消选中
    if (info && !info.checked) {
        selectedTableData.value = selectedTableData.value.filter(item => item.id != id)
    }
    // 复选框状态改变
    let arr = []
    tableInfo.value.forEach((item) => {
        if (item.checked) {
            arr.push({
                ...item,
            })
        }
    })
    // selectedTableData.value 已经有的选中的  arr  筛选出  不在selectedTableData.value 中的
    let newArr = arr.filter(item => {
        if (selectedTableData.value.findIndex(i => i.database_id == item.database_id) == -1) {
            return item
        }
    })
    if (selectedTableData.value.length < 5) {
        selectedTableData.value = [...selectedTableData.value, ...newArr]
        normalizeSelectedTableData()
        emits('showCharts', selectedTableData.value);
    } else {
        tableInfo.value.forEach(item => {
            if (item.id == id)
                item.checked = false
        })
        showMessage('info', getLangValue('dashboard.selectedLength'))
        return
    }

}
const showInstard = (id) => {
    //显示指标数据
    // selectedIndex.value = index;
    showTable.value = 1
    emits('showInstandard', id);

}

const setIndex = (index) => {
    // 当前选择数据
    selectedIndex.value = index;
    selectedProductId.value = tableInfo.value[index].id;
}

const sort = (head) => {
    // 排序
    const currentSortField = head.sortField || head.key
    const nextOrder = searchInfo.value.sortField === currentSortField && searchInfo.value.orderBy === 'asc' ? 'desc' : 'asc'
    searchInfo.value = {
        orderBy: nextOrder,
        sortField: currentSortField,
    }
}


// watch(selectedIndex, (val) => {
//     tableInfo.value.forEach(item => {
//         item.checked = false
//     })
//     changCheckBox()
//     //选中当前
//     tableInfo.value[val].checked = true
//     changCheckBox()
// },)

onMounted(() => {
    // getIndicatorCategory();
    // console.log(props.dashboardType);
    if (props.dashboardType == 'quality') {
        table_head.value = [
            { name: 'NO.', width: '2%', checked: true },
            { name: getLangValue("product-template.productName"), width: '9%', key: 'name', sortField: 'name', sortable: true, checked: true }, //产品名称
            { name: getLangValue("dashboard.quality.quality_index_query"), width: '9%', key: 'action', checked: true, }, // 质量指标查询
            { name: getLangValue("product-template.price"), width: '9%', key: 'price', checked: true }, //价格
            { name: getLangValue("product-template.size"), width: '9%', key: 'size', checked: true }, //尺寸
            { name: getLangValue("product-template.color"), width: '9%', key: 'color', checked: true }, //颜色
            { name: getLangValue("product-template.origin"), width: '9%', key: 'origin', checked: true }, //产地
            { name: getLangValue("product-template.targetmarket"), width: '9%', key: 'targetmarket', checked: true }, //目标市场
            { name: getLangValue("product-management.supplier"), width: '9%', key: 'supplier', checked: true }, //供应商
            { name: getLangValue("dashboard.listingTime"), width: '9%', key: 'release_time', checked: true }, //上架时间
        ]
    } else if (props.dashboardType == 'environment') {
        table_head.value = [
            { name: 'NO.', width: '2%', checked: true },
            { name: getLangValue("product-template.productName"), width: '9%', key: 'name', sortField: 'name', sortable: true, checked: true }, //产品名称
            { name: getLangValue("dashboard.environment.pef_value"), width: '9%', sortable: true, key: 'total_value', sortField: 'total_value', checked: true, }, // PEF值
            { name: getLangValue("dashboard.environment.environment_index_query"), width: '9%', key: 'action', checked: true, }, // 环境指标查询
            { name: getLangValue("product-template.price"), width: '9%', key: 'price', checked: true }, //价格
            { name: getLangValue("product-template.size"), width: '9%', key: 'size', checked: true }, //尺寸
            { name: getLangValue("product-template.color"), width: '9%', key: 'color', checked: true }, //颜色
            { name: getLangValue("product-template.origin"), width: '9%', key: 'origin', checked: true }, //产地
            // { name: getLangValue("dashboard.environment.passport_tableHeader5"), width: '9%', key: 'origin', checked: true }, //产地
            { name: getLangValue("product-template.targetmarket"), width: '9%', key: 'targetmarket', checked: true }, //目标市场
            { name: getLangValue("product-management.supplier"), width: '9%', key: 'supplier', checked: true }, //供应商
            { name: getLangValue("dashboard.listingTime"), width: '9%', key: 'release_time', checked: true }, //上架时间

        ]
    } else if (props.dashboardType == 'esg') {
        table_head.value = [
            { name: 'NO.', width: '2%', checked: true },
            { name: getLangValue("product-template.productName"), width: '9%', key: 'name', sortField: 'name', sortable: true, checked: true }, //产品名称
            { name: getLangValue("dashboard.esg.esg_value"), width: '9%', key: 'total_value', sortField: 'total_value', sortable: true, checked: true, }, // ESG综合指标
            { name: getLangValue("dashboard.esg.esg_index_query"), width: '9%', key: 'action', checked: true, }, // ESG指标查询
            { name: getLangValue("product-template.price"), width: '9%', key: 'price', checked: true }, //价格
            { name: getLangValue("product-template.size"), width: '9%', key: 'size', checked: true }, //尺寸
            { name: getLangValue("product-template.color"), width: '9%', key: 'color', checked: true }, //颜色
            { name: getLangValue("product-template.origin"), width: '9%', key: 'origin', checked: true }, //产地
            // { name: getLangValue("dashboard.environment.passport_tableHeader5"), width: '9%', key: 'origin', checked: true }, //产地
            { name: getLangValue("product-template.targetmarket"), width: '9%', key: 'targetmarket', checked: true }, //目标市场
            { name: getLangValue("product-management.supplier"), width: '9%', key: 'supplier', checked: true }, //供应商
            { name: getLangValue("dashboard.listingTime"), width: '9%', key: 'release_time', checked: true }, //上架时间

        ]
    } else if (props.dashboardType == 'circularity') {
        table_head.value = [
            { name: 'NO.', width: '2%', checked: true },
            { name: getLangValue("product-template.productName"), width: '9%', key: 'name', sortField: 'name', sortable: true, checked: true }, //产品名称
            { name: getLangValue("dashboard.circularity.circularity_value"), width: '9%', sortable: true, key: 'total_value', sortField: 'total_value', checked: true, }, // circularity综合指标
            { name: getLangValue("dashboard.circularity.circularity_index_query"), width: '9%', key: 'action', checked: true, }, // circularity指标查询
            { name: getLangValue("product-template.price"), width: '9%', key: 'price', checked: true }, //价格
            { name: getLangValue("product-template.size"), width: '9%', key: 'size', checked: true }, //尺寸
            { name: getLangValue("product-template.color"), width: '9%', key: 'color', checked: true }, //颜色
            { name: getLangValue("product-template.origin"), width: '9%', key: 'origin', checked: true }, //产地
            // { name: getLangValue("dashboard.environment.passport_tableHeader5"), width: '9%', key: 'origin', checked: true }, //产地
            { name: getLangValue("product-template.targetmarket"), width: '9%', key: 'targetmarket', checked: true }, //目标市场
            { name: getLangValue("product-management.supplier"), width: '9%', key: 'supplier', checked: true }, //供应商
            { name: getLangValue("dashboard.listingTime"), width: '9%', key: 'release_time', checked: true }, //上架时间

        ]
    } else if (props.dashboardType == 'comfort') {
        table_head.value = [
            { name: 'NO.', width: '2%', checked: true },
            { name: getLangValue("product-template.productName"), width: '9%', key: 'name', sortField: 'name', sortable: true, checked: true }, //产品名称
            // { name: getLangValue("dashboard.comfort.circularity_value"), width: '9%', sortable: true, key: 'total_value', checked: true, }, // circularity综合指标
            { name: getLangValue("dashboard.comfort.comfort_index_query"), width: '9%', key: 'action', checked: true, }, // 感官舒适性指标查询
            { name: getLangValue("product-template.price"), width: '9%', key: 'price', checked: true }, //价格
            { name: getLangValue("product-template.size"), width: '9%', key: 'size', checked: true }, //尺寸
            { name: getLangValue("product-template.color"), width: '9%', key: 'color', checked: true }, //颜色
            { name: getLangValue("product-template.origin"), width: '9%', key: 'origin', checked: true }, //产地
            // { name: getLangValue("dashboard.environment.passport_tableHeader5"), width: '9%', key: 'origin', checked: true }, //产地
            { name: getLangValue("product-template.targetmarket"), width: '9%', key: 'targetmarket', checked: true }, //目标市场
            { name: getLangValue("product-management.supplier"), width: '9%', key: 'supplier', checked: true }, //供应商
            { name: getLangValue("dashboard.listingTime"), width: '9%', key: 'release_time', checked: true }, //上架时间

        ]
    }
})

watch(pageSize, () => {
    // 分页size切换
    currentPage.value = 1;
    emits('pageChange', { currentPage: currentPage.value, pageSize: pageSize.value, keyword2: keyword.value, })
})

watch(currentPage, () => {
    // 当前页
    emits('pageChange', { currentPage: currentPage.value, pageSize: pageSize.value, keyword2: keyword.value, })
})


watch(productsList, () => {
    // 设置分页数据 总数
    setTableData();
    total.value = productList_total.value
}, { deep: true })

watch(searchInfo, (val) => {
    // 排序 部分dashboard没有排序的功能
    emits('sort', val);
}, { deep: true })

defineExpose({
    currentPage,
    selectedTableData,
})

</script>
<template>
    <div class="productsTable1 px-3 py-2 " style="height: calc(100% - 1rem) ">
        <div class="search d-flex align-items-center justify-content-between">
            <div class="form-icon">
                <input style="width: 250px;" clearable class="form-control form-control-icon" v-model="keyword" required
                    :placeholder="getLangValue('dashboard.input7')" />
                <i class="ri-search-line"></i>
            </div>
            <button type="button" class="btn btn-success mx-3" @click="search()" style="min-width: 93px;">
                {{ getLangValue("base.search") }}
            </button>
        </div>
        <!-- 选中数据 -->
        <div class="d-flex my-2">
            <div v-for="(item, key) in selectedTableData" :key="key" class="d-flex align-items-center mx-3 cursor-pointer" :title="item.name">
                <div :style="{ backgroundColor: colors[key], width: '15px', height: '15px', 'border-radius': '2px' }"
                    class="me-2"></div>
                NO.{{key+1}}-{{ item.name.slice(0, 4) }}
                <i class="ri-delete-bin-line cursor-pointer ms-2" style="color: #ED5E5E;" @click="remove(key)"></i>
            </div>
        </div>
        <!-- </div> -->
        <div style="flex-direction: column; height: calc(100% - 60px);">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <!-- style="height:calc(100% - 60px - 1rem); overflow-y: auto;" -->
                <div class="my-scroll-bar" style=" height: calc(100% - 45px); overflow-y: auto;">
                    <table class="table table-nowrap">
                        <!-- table-nowrap -->
                        <thead class="table-light">
                            <tr>
                                <th width="1%"></th>
                                <template v-for="(head, index) in table_head.filter(item => item.checked)" :key="index">
                                    <th v-if="head.type == 'reference'" scope="col"
                                        style="color: #2E404C;min-width: 200px">
                                        <div class="d-flex align-items-center">{{ head.name }}</div>
                                    </th>
                                    <th v-else scope="col" style="color: #2E404C; min-width: 100px; white-space: normal; max-width: 150px; word-wrap: break-word; word-break: break-all;
                                        position: relative;" :width="head.width">
                                        <div :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                                            class="d-flex align-items-center">
                                            <div style="max-width: 130px;">{{ head.name }}</div>
                                            <div class="sortable mx-2 cursor-pointer desc"
                                                :class="searchInfo.sortField == (head.sortField || head.key) && searchInfo.orderBy == 'asc' ? 'sortasc' : searchInfo.sortField == (head.sortField || head.key) && searchInfo.orderBy == 'desc' ? 'sortdesc' : ''"
                                                v-if="head.sortable"
                                                style="position: relative; width: 14px; height: 10px;"
                                                @click="sort(head)">
                                            </div>
                                        </div>

                                    </th>

                                </template>
                                <!-- <th width="4%">{{ getLangValue('base.operation') }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="cursor-pointer" v-for="(info, index) in tableInfo" :key="index"
                                style="vertical-align: middle" :class="selectedIndex == index ? 'activeTr' : ''"
                                @click.stop="setIndex(index)">
                                <td>
                                    <input @change="changCheckBox(info.id, info)" class="form-check-input" type="checkbox"
                                        v-model="info.checked" @click.stop="() => { }"
                                        aria-label="Checkbox for following text input">
                                </td>
                                <td v-for="(item, kk) in table_head.filter(item => item.checked)" :key="kk"
                                    style="word-wrap: break-word; white-space: normal;">
                                    <img v-if="item.key === 'qrcodeImgUrl' && info.qrcodeImgUrl"
                                        :src="info.qrcodeImgUrl" class="cursor-pointer"
                                        style="width: 48px;height: 48px;" @click="showImageCode(info.qrcodeImgUrl)">
                                    <template v-else>
                                        <div v-if="item.key == 'origin'">
                                            {{ info.production_line && info.production_line.place_of_origin ?
                                                `${info.production_line.place_of_origin.name}-${info.production_line.place_of_origin.province}`
                                                :
                                                '' }}
                                        </div>
                                        <div v-else-if="item.key == 'supplier'">
                                            {{ info.organization && info.organization.company_name }}
                                        </div>
                                        <div v-else-if="item.key == 'price'">
                                            {{ info.price_unit + info.price }}
                                        </div>
                                        <span v-else-if="item.key == 'targetmarket'">
                                            {{ i18n.global.locale == 'en' ?
                                                info.production_line?.database_template?.destination_market?.title_en
                                                : info.production_line?.database_template?.destination_market?.title
                                            }}
                                        </span>
                                        <div v-else-if="item.key == 'total_value'" style="position: relative;">
                                            {{ info.total_value }}

                                        </div>
                                        <span v-else-if="item.key == 'release_time'">
                                            {{ info.release_time ? moment(info.release_time).format('YYYY-MM-DD') : ''
                                            }}
                                        </span>
                                        <span v-else-if="item.key == 'action'">
                                            <a style="color: #0AB39C; text-decoration: underline !important; cursor: pointer;"
                                                @click.stop="showInstard(info.id)">{{
                                                    getLangValue('dashboard.view_indicators')
                                                }}</a>
                                        </span>
                                        <span v-else>
                                            {{ kk == 0 ? index + 1 : info[item.key] }}
                                        </span>

                                    </template>
                                </td>
                                <!-- <td>
                                    <i class="ri-eye-fill cursor-pointer" style="font-size: 24px;"
                                        @click.stop="showInstard(info.id)" />
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <Empty v-if="tableInfo.length == 0" style="margin-top: 20%;"></Empty>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
        </PreviewImg>
    </div>

</template>
<style scoped lang="scss">
.productsTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            height: 100%;
            background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }


        :deep(.el-input__inner) {
            color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                color: white
            }
        }

        .form-control {
            background-color: #4a5056;
            color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: white;
        }

        .my-pagination {
            color: white;

            :deep(.page_total) {
                color: white !important;
            }
        }
    }
}

.productsTable1 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            height: 100%;
            // background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            font-size: 0.8125rem;
            color: #878a99 !important;
        }

        :deep(.el-cascader .el-input__inner) {
            &::placeholder {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }
        }

        :deep(.el-select__selected-item.el-select__placeholder) {
            font-size: 0.8125rem;
            color: #212529;
        }


        :deep(.el-input__inner) {
            font-size: 0.8125rem;
            color: #2E404C;
        }

        .form-icon {
            display: inline-block;

            i {
                color: #2E404C
            }
        }

        .form-control {
            // background-color: #4a5056;
            color: #2E404C;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #2E404C;
        }

        .activeTr {
            background-color: #ececf5;
        }

        .my-pagination {
            color: #2E404C;

            :deep(.page_total) {
                color: #2E404C !important;
            }
        }
    }

    .sortActive {
        i {
            color: black !important;
        }

    }

    .sortable {
        &::after {
            content: "\f035d";
            position: absolute;
            right: .5rem;
            top: 0px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }

        &::before {
            content: "\f0360";
            position: absolute;
            right: .5rem;
            top: -8px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }
    }

    .sortdesc {
        &::after {
            color: black;
        }
    }

    .sortasc {
        &::before {
            color: black;
        }
    }
}
</style>
